// extracted by mini-css-extract-plugin
export default {"checkbox":"style_checkbox__4nijI","checked":"style_checked__VoK5R"};